import { createSlice } from "@reduxjs/toolkit";
import {
  fetchGridStackLists,
  fetchHomePage,
  editDashboardSave,
  fetchDataVisData,
  fetchNaruhoneData,
  getPublicMessages,
} from "src/thunks/dashboardThunk";

const initialMessageList = [
  {
    username: "lionelkaya",
    special: "dev",
    message:
      "leave a anonymous message/chat if you want :)",
  },
];

//new data to handle thunks
//{status, data, error}

const getItemContext = (state) => {
  let dashboardData = state.gridStackList.find(
    (gsl) => gsl.id === state.currentStackListId
  ).dashboardData;
  let item = dashboardData.find((item) => item.id === state.lastClickedItemId);
  if (item.context == null) {
    item.context = {};
  }
  return item.context;
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    naruhone: null,
    gridHomePage: null,
    gridHomePageStatus: "idle",
    gridStackList: [],
    gridStackListStatus: "idle",
    currentStackListId: "customstack",
    lastClickedItemId: null,
    currentDashboardSaveStatus: null,
    currentDashboardMode: "view",
    status: "idle",
    chat: {
      username: null,
      messageList: initialMessageList,
    },
    error: null,
    dataVis: {status:"idle", data: null, error: null},
  },
  reducers: {
    clearChatList(state, action) {
      state.chat.messageList = [];
    },
    setChatUsername(state, action) {
      state.chat.username = action.payload;
    },
    setlastClickedItemId(state, action) {
      state.lastClickedItemId = action.payload;
    },
    addChatMessage(state, action) {
      state.chat.messageList = [...state.chat.messageList, action.payload];
    },
    setCurrentStackListId(state, action) {
      state.currentStackListId = action.payload;
    },
    setGridHomePage(state, action) {
      state.gridHomePage = action.payload;
      state.gridHomePageStatus = "succeeded";
    },
    removeItemFromDashboard(state, action) {
      const { dashboardId, itemId } = action.payload;

      const dashboard = state.gridStackList.find((d) => d.id === dashboardId);
      if (dashboard) {
        // Filter out the item with the matching id from the gridStackList
        dashboard.dashboardData = dashboard.dashboardData.filter(
          (item) => item.id !== itemId
        );
        if (state.lastClickedItemId === itemId) {
          state.lastClickedItemId = null;
        }
      }
    },
    editDashboardItems(state, action) {
      const { dashboardId, items } = action.payload;
      //currentStackListId
      const dashboard = state.gridStackList.find((d) => d.id === dashboardId);
      if (dashboard) {
        dashboard.dashboardData = dashboard.dashboardData = items;
      }
    },
    editContextTitle(state, action) {
      if (state.lastClickedItemId != null) {
        const { newTitle } = action.payload;
        let context = getItemContext(state);
        context.title = newTitle;
      }
    },
    addContextSection(state, action) {
      let context = getItemContext(state);
      if (context.sections == null) {
        context.sections = [
          { heading: null, description: null, imageUrls: [] },
        ];
      } else {
        context.sections.push({
          heading: null,
          description: null,
          imageUrls: [],
        });
      }
    },
    editContextSectionHeading(state, action) {
      if (state.lastClickedItemId != null) {
        const { newHeading, sectionIndex } = action.payload;
        let context = getItemContext(state);
        let currentSection = context.sections[sectionIndex];
        currentSection.heading = newHeading;
      }
    },
    editContextSectionDescription(state, action) {
      if (state.lastClickedItemId != null) {
        const { newDescription, sectionIndex } = action.payload;
        let context = getItemContext(state);
        let currentSection = context.sections[sectionIndex];
        currentSection.description = newDescription;
      }
    },
    removeContextSection(state, action) {
      if (state.lastClickedItemId != null) {
        const { sectionIndex } = action.payload;
        let context = getItemContext(state);
        context.sections = context.sections.filter(
          (_, i) => i !== sectionIndex
        );
      }
    },
    setCurrentDashboardMode(state, action) {
      state.currentDashboardMode = action.payload;
    },
    editDashboardItemByItem(state, action){
      const item = action.payload;
      let itemToEdit;
      for(let i = 0; i < state.gridStackList.length; i++){
        itemToEdit = state.gridStackList[i].dashboardData.find(i => i.id === item.id);
        if(itemToEdit !== undefined){
        break;
        };
      }
      if(!itemToEdit){
        console.log("ERROR ITEMTOEDIT NULL");
      }else{
        itemToEdit.itemData = item.itemData;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGridStackLists.pending, (state) => {
        state.status = "loading";
        state.gridStackListStatus = "loading";
      })
      .addCase(fetchGridStackLists.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.gridStackListStatus = "succeeded";
        state.gridStackList = action.payload.dashboards;
      })
      .addCase(fetchGridStackLists.rejected, (state, action) => {
        state.status = "failed";
        state.gridStackListStatus = "failed";
        state.error = action.error.message || action.payload; // Set the error message
      })
      .addCase(fetchHomePage.pending, (state) => {
        state.gridHomePageStatus = "loading";
      })
      .addCase(fetchHomePage.fulfilled, (state, action) => {
        state.gridHomePageStatus = "succeeded";
        state.gridHomePage = action.payload;
      })
      .addCase(fetchHomePage.rejected, (state, action) => {
        state.gridHomePageStatus = "failed";
        state.error = action.error.message || action.payload; // Set the error message
      })
      .addCase(editDashboardSave.pending, (state) => {
        state.currentDashboardSaveStatus = "loading";
      })
      .addCase(editDashboardSave.fulfilled, (state) => {
        state.currentDashboardSaveStatus = "succeeded";
      })
      .addCase(fetchDataVisData.fulfilled , (state,action) => {
          state.dataVis.data = action.payload;
          state.dataVis.status = "fulfilled";
      })
      .addCase(fetchDataVisData.pending , (state) => {
          state.dataVis.status = "pending";
      })
      .addCase(getPublicMessages.fulfilled , (state, action) => {
          state.dataVis.status = "fulfilled";
          state.chat.messageList = action.payload;
      })
      .addCase(fetchNaruhoneData.fulfilled , (state,action) => {
          state.naruhone = action.payload;
      });
      
  },
});

//selectors
export const getAllDashboards = (state) => state.dashboard.gridStackList;
export const getCurrentDashboardMode = (state) => state.dashboard.currentDashboardMode;
export const getContextOfLastClickedItem = (state) => {
  if (
    state.dashboard.currentStackListId === null ||
    state.dashboard.lastClickedItemId === null
  )
    return null;

    let currentDashboard;
    if(state.dashboard.currentStackListId === "homepagepublic"){
      currentDashboard = state.dashboard.gridHomePage;
    }else{
      currentDashboard = state.dashboard.gridStackList.find(
        (gsl) => gsl.id === state.dashboard.currentStackListId
      );
    } 

    if(currentDashboard == null){return null;}

  return currentDashboard.dashboardData.find((item) => item.id === state.dashboard.lastClickedItemId)
    ?.context;
};
export const getStatusAndError = (state) => ({
  status: state.dashboard.status,
  error: state.dashboard.error,
});
export const getCurrentStackListId = (state) =>
  state.dashboard.currentStackListId;

export const {
  setCurrentStackListId,
  setGridHomePage,
  removeItemFromDashboard,
  addChatMessage,
  setChatUsername,
  clearChatList,
  editDashboardItems,
  setlastClickedItemId,
  editContextTitle,
  addContextSection,
  editContextSectionHeading,
  editContextSectionDescription,
  removeContextSection,
  setCurrentDashboardMode,
  editDashboardItemByItem,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
